<script>
import Loader from "@/components/widgets/loader.vue";

export default {
  name: 'AbilityModal',
  props:[
    "list"
  ],
  components: {
    Loader
  },
  data() {
    return {
      form: {},
      submitted: false,
      loading: false,
      abilities:[],
      selected: {},
    };
  },
  created(){
    this.$http.post(`/abilites`)
    .then(response => this.abilities = response.data)
  },
  watch:{
    list(data){
       const { id } = data
       this.selected = {}
       this.loading = true
       this.$http.post(`/dealers/${id}/abilites`)
                .then(resp => {
                  //this.selected = resp.data
                  let object= []
                  resp.data.forEach((id) => {
                    object[id] = true
                    this.selected = Object.assign({ ...object } , this.selected);
                  });
                  this.loading = false
                })
    }
  },
  methods: {
    change(data, event){
      if(event){
        let object= []
        const checked = event.target.checked
        if(checked == false && this.selected.hasOwnProperty(data.id)){
           delete this.selected[data.id];
        }else{
          object[data.id] = event.target.checked
        }
        this.selected = Object.assign({ ...object } , this.selected);
      }
    },  
    handleSubmit() {
      this.submitted = true;
      const { id } = this.list
      let data = []
      for (let key in this.selected) {
          data.push(key);
        
      }
      this.$http.put(`/dealers/${id}/abilites`, data)
                .then(resp => resp)
                .catch(error => error)
      this.submitted = false;
    },
    close(){
      this.$parent.$bvModal.hide('modal-ability')
    },
    all(id){
      let object= []
      this.abilities[id].sub.map(e =>{
        if(typeof this.selected[e.id] == undefined){
          object[e.id] = true
        }else{
          object[e.id] = !this.selected[e.id]
        }
      })
      this.selected = Object.assign({ ...object } , this.selected); 
    }
  },
};
</script>

<template>
  <b-modal id="modal-ability" title="Yetkiler"  no-close-on-backdrop hide-footer>
    <form @submit.prevent="handleSubmit">
      <Loader :loading="true" :load="loading"></Loader>
        <div class="row" v-if="!loading">
          <div class="col-md-12">
              <div class="card1">
                <div class="card-body1">
                   <div role="tablist">
                      <b-card no-body class="mb-1 shadow-none"
                        v-for="(ext, index) in abilities" 
                        :key="index"
                      >
                        <b-card-header header-tag="header" role="tab">
                          <h6 class="m-0" style="align-items: center;">
                            <div class="row">
                              <div class="col-md-10">
                                <a
                                  v-b-toggle="`accordion-${index}`"
                                    class="text-dark"
                                    href="javascript: void(0);"
                                  > {{ ext.title }} <br>
                                  <cite style="font-size:10!important" class="text-warning" v-if="ext.hasOwnProperty('sub')">Alt Yetkilere Sahip</cite>
                                  </a>
                                </div>
                                <div class="col">
                                   <input
                                    value="1"
                                    style="float:right;"
                                    @change="change(ext,$event)"
                                    v-model="selected[ext.id]"
                                    :class="`form-check-input ${ext.id}`"
                                    type="checkbox"
                                    />
                                </div>
                            </div>
                          </h6>
                        </b-card-header>
                        <b-collapse :id="`accordion-${index}`" visible accordion="my-accordion" role="tabpanel"  v-if="ext.sub">
                          <b-card-body>
                            <div class="table-responsive">
                              <table class="table table-nowrap table-hover mb-0">
                                <thead>
                                  <tr>
                                    <td colspan=2 class="text-end" @click="all(index)">Tümünü Seç</td>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr 
                                      v-for="(ext1, index) in ext.sub" 
                                      :key="index"
                                  >
                                      <th >{{ ext1.title }}</th>
                                      <td > 
                                      <input
                                          @change="change(ext1,$event)"
                                          value="1"
                                          v-model="selected[ext1.id]"
                                          :class="`form-check-input ${ext1.id}`"
                                          type="checkbox"
                                      />
                                      </td>
                                  </tr>
                                  </tbody>
                              </table>
                            </div>
                          </b-card-body>
                        </b-collapse>
                      </b-card>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="d-flex justify-content-between mt-3">
        <div>
          <b-button variant="danger"  v-if="form.id" @click="remove(form.id)">Sil</b-button>
        </div>
        <div>
          <b-button variant="light" @click="close()">Vazgeç</b-button>
          <b-button 
            v-if="form.id"
            type="submit" 
            variant="warning" 
            class="ms-1"
            >Güncelle
          </b-button>
          <b-button 
            v-else
            type="submit" 
            variant="success" 
            class="ms-1"
            >Oluştur
          </b-button>
        </div>
        </div>
      </form>
    </b-modal>
</template>